<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-13 14:53:39
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-23 09:35:09
 * @FilePath: /partner.chaoyongtuan.com/src/modules/sample/apply/rules/editDialog.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" :before-close="beforeClose" width="540px">
		<Tip content="达人自主申样校验仅符合规则可申样，商务管理后台申样不校验规则" type="warning" colorClass="yx-color-warning"></Tip>
		<el-form :model="form" ref="form" label-width="120px" class="mt-24" :rules="rules" v-loading="loading">
			<el-form-item label="粉丝量" prop="fans_num">
				<el-input v-model="form.fans_num" placeholder="请输入">
					<template slot="prepend">≥</template>
				</el-input>
			</el-form-item>
			<el-form-item :label="salesLabel" prop="sales">
				<el-input v-model="form.sales" placeholder="请输入">
					<template slot="prepend">≥</template>
				</el-input>
			</el-form-item>
			<el-form-item :label="salesAmountLabel" prop="sale_amount">
				<el-input v-model="form.sale_amount" placeholder="请输入">
					<template slot="prepend">≥</template>
					<template slot="append">元</template>
				</el-input>
			</el-form-item>
			<el-form-item>
				<span slot="label" class="flex-row flex-just-end"> <explain content="白名单用户不校验申样门槛"></explain>白名单用户 </span>
				<anchor-select ref="anchorSelect" v-model="form.anchor_ids" :platformId="platformId" class="width100"></anchor-select>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancel">取消</el-button>
			<el-button type="primary" @click="confirm" :disabled="loading">确认</el-button>
		</span>
	</el-dialog>
</template>
<script>
import AnchorSelect from '@/modules/anchor/select';
import Explain from '@/components/common/explain';
import { getSampleRule, setSampleRule } from '@/api/sampleOrder';
import { checkIsIntWidthZero } from '@/utils/validate';
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP } from '@/utils/dataMap';
const confs = {
	[PLATFORM_DY.value]: {
		salesLabel: '月橱窗销量',
		salesAmountLabel: '月橱窗销售额',
	},
	[PLATFORM_KS.value]: {
		salesLabel: '月订单量',
		salesAmountLabel: '月销售额',
	},
	[PLATFORM_SP.value]: {
		salesLabel: '月订单量',
		salesAmountLabel: '月销售额',
	},
};
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
	},
	created() {
		this.$Bus.$on('show', ({ mode, goods }) => {
			if (!['batch', 'single'].includes(mode)) {
				return;
			}
			this.mode = mode;
			this.goods = goods;
			// 修改单个商品时，获取商品的申样门槛
			this.isSingle && this.getSingleGoodsRule();
			this.show();
		});
	},
	data() {
		return {
			form: {
				fans_num: '',
				sales: '',
				sale_amount: '',
				anchor_ids: [],
			},
			rules: {
				fans_num: [{ requied: false }, { validator: checkIsIntWidthZero, trigger: 'blur', msg: '只能为大于等于0的整数' }],
				sales: [{ requied: false }, { validator: checkIsIntWidthZero, trigger: 'blur', msg: '只能为大于等于0的整数' }],
				sale_amount: [{ requied: false }, { validator: checkIsIntWidthZero, trigger: 'blur', msg: '只能为大于等于0的整数' }],
			},
			mode: 'single', // 修改申样门槛的模式，包括批量修改和单个修改
			visible: false,
			goods: [],
			loading: false,
		};
	},
	computed: {
		isBatch() {
			return this.mode === 'batch';
		},
		isSingle() {
			return this.mode === 'single';
		},
		title() {
			return `${this.isBatch ? '批量' : ''}修改申样门槛`;
		},
		goodsLength() {
			return this.goods.length;
		},
		selfGoods() {
			return this.goods.filter(item => item.is_self).length;
		},
		salesLabel() {
			return confs[+this.platformId].salesLabel;
		},
		salesAmountLabel() {
			return confs[+this.platformId].salesAmountLabel;
		},
	},
	methods: {
		show() {
			this.visible = true;
		},
		hide() {
			this.clean();
			this.visible = false;
		},
		cancel() {
			this.clean();
			this.visible = false;
		},
		confirm() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.setGoodsRule();
				}
			});
		},
		clean() {
			Object.assign(this.$data, this.$options.data());
			this.$refs.form.resetFields();
			this.$refs.anchorSelect.reset();
		},
		beforeClose(done) {
			this.clean();
			done();
		},
		/**
		 * @description: 获取单个商品申样门槛
		 * @return {*}
		 * @acthor: Li Yong
		 * @Date: 2022-06-13 19:45:06
		 */
		async getSingleGoodsRule() {
			const [{ third_product_id, platform_id }] = this.goods;
			this.loading = true;
			try {
				const {
					fans_num = '',
					sales = '',
					sale_amount = '',
					anchor_ids = [],
				} = await getSampleRule({
					third_product_id,
					platform_id,
				});
				this.form = {
					fans_num: `${fans_num}`,
					sales: `${sales}`,
					sale_amount: `${sale_amount}`,
					anchor_ids,
				};
				this.loading = false;
			} catch (error) {
				this.$message.error(error);
				this.loading = false;
			}
		},
		/**
		 * @description: 设置商品申样门槛
		 * @return {*}
		 * @acthor: Li Yong
		 * @Date: 2022-06-13 19:44:45
		 */
		async setGoodsRule() {
			const product_ids = this.goods.map(item => item.product_id).join();
			const anchor_ids = this.form.anchor_ids instanceof Array ? this.form.anchor_ids.join() : '';
			await setSampleRule({
				product_ids,
				...this.form,
				anchor_ids,
				platform_id: this.platformId,
			});
			this.$message.success('保存成功，规则立即生效');
			this.clean();
			this.$emit('refresh');
			this.visible = false;
		},
	},
	components: {
		AnchorSelect,
		Explain,
	},
	beforeDestroy() {
		this.$Bus.$off('show');
	},
};
</script>
